<template>
  <div class="choicequestion">
    <div class="choicequestion__header"></div>
    <div class="choicequestion__body">
      <div class="choicequestion__main">
        <BigImageDialog ref="BigImageDialog" />
        <div class="choicequestion__main__content">
          <pre class="choicequestion__main-title">{{ question && question.content }}</pre>
          <div class="choicequestion__main-titlepic" v-if="hasTitlePic()">
            <img class="choicequestion__main-titlepic-img" :src="question.imageUrl"
              @dblclick="ZoomIn(question.imageUrl)" />
          </div>
        </div>
        <div class="choicequestion__main__options">
          <ul class="choicequestion__main-list columns-2" v-if="hasOptionPic()">
            <li v-for="(el, index) in question.optionItems" :key="`${question.id}${index}`" :class="genOptionpicCSS(el)"
              @click="handleSelect(question.optionItems, index)">
              <div style="display: flex;">
                <span class="choicequestion__main-option_label">{{el.no}}</span>
                <pre class="choicequestion__main-context">{{ el.content }}</pre>
              </div>
              <img class="choicequestion__main-img-pic" :src="el.imageUrl" @dblclick.stop="ZoomIn(el.imageUrl)" />
            </li>
          </ul>
          <ul class="choicequestion__main-list" v-else>
            <li v-for="(el, index) in question.optionItems" :class="genOptionCSS(el)" :key="`${question.id}${index}`"
              @click="handleSelect(question.optionItems, index)">
              <span class="choicequestion__main-option_label">{{el.no}}</span>
              <pre class="choicequestion__main-context">{{ el.content }}</pre>
            </li>
          </ul>
          <div class="choicequestion__main-tail">
            <span v-if="!isLastQuestion" :class="genBtnCSS()" @click="handleEnsure">
              确定
            </span>
            <el-tooltip v-else class="item" effect="dark" :content="tip" placement="top">
              <span :class="genBtnCSS()" @click="handleEnsure">
                确定
              </span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import BigImageDialog from '@/components/BigImageDialog.vue';
import { Tooltip } from 'element-ui';

export default {
  name: 'ChoiceQuestion',
  components: {
    BigImageDialog,
    ElTooltip: Tooltip,
  },
  props: {
    question: {
      type: Object,
      default: () => ({
        optionItems: [],
      }),
    },
    bundleExamStatus: {
      type: Number
    },
    isLastQuestion: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSelect: false,
      canShowAnswer: false,
      btnDisabled: false,
      tip: '本题为该目录最后一题，作答完成后，请在右上角提交该目录',
    };
  },

  watch: {
    question() {
      this.$forceUpdate();
    },
  },

  methods: {
    hasTitlePic() {
      if (this.question && this.question.imageUrl) {
        return true;
      }
      return false;
    },
    hasOptionPic() {
      if (
        this.question
        && this.question.optionItems.some((item) => {
          if (item.imageUrl) {
            return true;
          }
          return false;
        })
      ) {
        return true;
      }
      return false;
    },
    genOptionCSS(el) {
      const arr = ['choicequestion__main-option'];
      if (el.selected) {
        arr.push('choicequestion__main-option--active');
      }
      return arr;
    },
    genOptionpicCSS(el) {
      const arr = ['choicequestion__main-option-pic'];
      if (el.selected) {
        arr.push('choicequestion__main-option-pic--active');
      }
      return arr;
    },
    handleSelect(list, index) {
      if (this.readonly) return;
      list.some((item) => {
        if (item.selected) {
          /* eslint-disable-next-line no-param-reassign */
          delete item.selected;
          return true;
        }
        return false;
      });
      /* eslint-disable-next-line no-param-reassign */
      list[index].selected = true;
      this.btnDisabled = false;
      this.$forceUpdate();
    },
    ZoomIn(uri) {
      this.$refs.BigImageDialog.openDialog(uri);
    },
    genBtnCSS() {
      const arr = ['choicequestion__main-btn'];
      const hasResult = this.question.optionItems.some((item) => {
        if (item.selected) {
          return true;
        }
        return false;
      })
      if (hasResult && !this.readonly && !this.btnDisabled) {
        arr.push('choicequestion__main-enable');
      } else {
        arr.push('choicequestion__main-disable');
      }
      return arr;
    },
    handleEnsure() {
      if (this.readonly) return;
      if (this.btnDisabled) {
        this.$elMessage({
          message: this.tip,
          type: 'error',
          offset: 60,
        });
        return;
      }
      let select;
      this.question.optionItems.some((item) => {
        if (item.selected) {
          select = item.no;
          return true;
        }
        return false;
      });

      if (!select) {
        return;
      }

      let correct;
      this.question.optionItems.some((item) => {
        if (item.isCorrect) {
          correct = item.no;
          return true;
        }
        return false;
      });

      this.question.correct = select === correct;

      this.$emit('ensure', {
        correct,
        chooseAnswer: select,
        isCorrect: select === correct,
        answerId: this.question.answerId,
        questionId: this.question.questionId,
      });

      if(this.isLastQuestion) {
        this.btnDisabled = true
      }

      this.$forceUpdate();
    },
    handleNext() {
      this.$emit('choiceFinish');
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "~@/assets/less/mixin.less";

.choicequestion {
  &__header {
    position: relative;
    padding: 8px;
    height: 48px;
    line-height: 32px;
    background-color: #37261f;
    &-logo {
      display: inline-block;
      width: 142px;
      height: 33px;
      vertical-align: middle;
      .bg-img("~@/assets/images/compiler_logo");
      background-repeat: no-repeat;
      background-size: 100%;
      cursor: pointer;
      &.nocursor {
        cursor: default !important;
      }
    }
  }
  &__input {
    width: 0;
    height: 0;
    opacity: 0;
  }
  &__img {
    max-width: 100%;
    max-height: 100%;
  }
  &__img-mask {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
  }
  &__body {
    position: absolute;
    top: 48px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    .bg-img('~@/assets/images/paper-question');
    background-size: 287px 497px;
    background-position: center;
  }
  &__main {
    margin: 42px 16px 33px;
    width: calc(100% - 32px);
    height: calc(100% - 106px);
    display: flex;
    &__content {
      flex: 500 500 500px;
      background:rgba(255,253,246,1);
      box-shadow:0px 0px 8px 0px rgba(0,0,0,0.2);
      border-radius:12px;
      margin-right: 16px;
      padding: 32px;
      font-size:18px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:25px;
      overflow: auto;
    }
    &__options {
      flex: 892 892 892px;
      background:rgba(255,253,246,1);
      box-shadow:0px 0px 8px 0px rgba(0,0,0,0.2);
      border-radius:12px;
      padding: 32px 33px 80px;
      overflow-y: visible;
      position: relative;
      z-index: 0;
    }
    &-title {
      margin: 0;
      color: #4a4a4a;
      font-size: 18px;
      font-weight: 500;
      font-family: "Microsoft Yahei", "Helvetica Neue", "Helvetica Arial", "Avenir,Segoe UI",
        "Hiragino Sans GB", STHeiti, "Microsoft Sans Serif";
      white-space: pre-wrap;
    }
    &-titlepic {
      background-color: #fff;
      border-radius: 8px;
      text-align: center;
      &-img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    &-list {
      margin: 0;
      padding: 0;
      overflow: auto;
      height: 100%;
    }
    &-option {
      margin-top: 10px;
      padding: 10px 0 12px 0px;
      position: relative;
      display: flex;
      &:first-child {
        margin-top: 0px;
        padding-top: 0px;
      }
    }
    &-icon {
      position: absolute;
      top: 0;
      left: 96px;
      display: block;
      width: 25px;
      height: 25px;
      background-color: #fff;
      border: 2px solid #edd69c;
      border-radius: 13px;
      text-align: center;
      cursor: pointer;
      &-center {
        display: inline-block;
        width: 13px;
        height: 13px;
        border-radius: 13px;
      }
    }
    &-context {
      margin: 0;
      margin-left: 13px;
      color: #4a4a4a;
      font-size: 18px;
      line-height: 28px;
      font-weight: 400;
      font-family: "Microsoft Yahei", "Helvetica Neue", "Helvetica Arial", "Avenir,Segoe UI",
        "Hiragino Sans GB", STHeiti, "Microsoft Sans Serif";
      white-space: pre-wrap;
      width: calc(100% - 40px);
    }
    &-list-pic {
      margin: 0;
      padding: 0 92px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    &-img-pic {
      margin: 25px 0 0;
      width: 100%;
      height: auto;
      cursor: pointer;
    }
    &-option--active,
    &-option-pic--active {
      .choicequestion__main-icon-center {
        background-color: #edd69c;
      }

    & .choicequestion__main-option-pic_label,& .choicequestion__main-option_label {
      color: #638733;
      background-color: transparent;
      &::before {
        border-color: #638733;
        background: radial-gradient(closest-side, #638733 6px,  transparent 6px);
      }
    }
    }
    &-answer {
      position: absolute;
      right: -114px;
      bottom: 46px;
      width: 172px;
      height: 137px;
      border: 2px solid;
      border-radius: 15px;
      text-align: center;
      &-label {
        margin: 25px auto 11px;
        color: #4a4a4a;
        font-size: 25px;
        font-weight: 500;
        text-align: center;
      }
    }
    &-answer--correct {
      background-color: #bbd35f;
      border-color: #4b7622;
    }
    &-answer--wrong {
      background-color: #f5c854;
      border-color: #af8b38;
    }
    &-tail {
      position: absolute;
      width: 100%;
      text-align: center;
      height:80px;
      bottom:0;
      left: 0;
      background:rgba(255,253,246,1);
      border-radius: 0 0 12px 12px;
      &::after {
        content: '';
        width: 100%;
        height: 5px;
        position: absolute;
        display: block;
        top: 0;
        z-index: -2;
        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.27);
      }
    }
    &-btn {
      display: inline-block;
      width: 100px;
      height: 35px;
      line-height: 31px;
      text-align: center;
      border-radius: 18px;
      position: absolute;
      top: calc(50% - 17px);
      left: calc(50% - 50px);
    }
    &-enable {
      background-color: #f1c151;
      border: 2px solid #b7885b;
      cursor: pointer;
      &:hover {
        color: #fff;
        background-color: #e6ad29;
      }
    }
    &-disable {
      background-color: #cecece;
      border: 2px solid #9d9d9d;
      cursor: not-allowed;
    }
    &-tip {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 200px;
      text-align: left;
      padding: 0px 10px;
      border: 2px solid;
      border-radius: 10px;
      transform: translate(70px, -50%);
      &-arrow {
        position: absolute;
        top: 50%;
        left: 0;
        display: block;
        width: 15px;
        height: 15px;
        transform: translate(-9px, -9px) rotate(45deg);
        border-left: 2px solid;
        border-bottom: 2px solid;
      }
      &-next {
        display: inline-block;
        width: 100px;
        height: 30px;
        line-height: 26px;
        border: 2px solid #000;
        border-radius: 15px;
        cursor: pointer;
      }
      &_correct {
        background-color: #ced882;
        border-color: #799748;
        .choicequestion__main-tip-arrow {
          background-color: #ced882;
          border-color: #799748;
        }
        .choicequestion__main-tip-next {
          background-color: #f1c151;
        }
      }
      &_wrong {
        background-color: #f1c151;
        border-color: #b7885b;
        .choicequestion__main-tip-arrow {
          background-color: #f1c151;
          border-color: #b7885b;
        }
        .choicequestion__main-tip-next {
          background-color: #fcf4e2;
        }
      }
    }
  }
  .choicequestion__main-option--active,.choicequestion__main-option-pic--active {
    background: transparent;

    .choicequestion__main-option_label,.talqs_options_content,.choicequestion__main-context {
      color: #638733;
      background-color: transparent;
    }
    .choicequestion__main-option_label::before {
      border-color: #638733;
      background: radial-gradient(closest-side, #638733 6px,  transparent 6px);
    }
    img {
      border: solid 2px #638733;
    }
  }
  .choicequestion__main-option_label {
    float: left;
    border: none;
    display: inline;
    width: auto;
    height: auto;
    line-height: 24px;
    color: #000;
    margin: 2px 0;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    flex: 1 0 auto;
    &::after {
      content: '.'
    }
    &::before {
      content: '';
      display: block;
      width:24px;
      height:24px;
      background:transparent;
      border:2px solid rgba(184,184,184,1);
      border-radius: 12px;
      float:left;
      margin-right: 12px;
    }
  }
}
.columns-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 25px;
  grid-column-gap: 41px;
}
</style>
